import { render, staticRenderFns } from "./EduContentFormWizardIcon.vue?vue&type=template&id=add049da&"
import script from "./EduContentFormWizardIcon.vue?vue&type=script&lang=js&"
export * from "./EduContentFormWizardIcon.vue?vue&type=script&lang=js&"
import style0 from "./EduContentFormWizardIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports